export interface ClosingEntryAccount {
    name: string; // name of the item
    number: string; // number of the account
    id: string; // unique id of the account
    type: string; // type of account (balance, income, expense, etc.)
    metadata: string; // meta data for the account if number is not unique
}
